import { Spin as AntdSpin } from "antd";

const SpinPolyfill: typeof AntdSpin = AntdSpin;

export default SpinPolyfill;